'use client';

import { useEffect } from 'react';
import useInterval from 'src/hooks/useInterval';
import useLstMetricsStore from '../useLstMetricsStore';
import { LstMetrics, SUPERSTAKE_ALL_LST, fetchLstMetrics } from '@drift/common';

/**
 * Keeps LST yield metris updated, needed for superstake APRs
 *
 * Only use this within pages/components that actually need all of the lst metrics data
 */
const useSyncLstMetricsStore = (pollingRateMs = 10_000) => {
	const setLstMetrics = useLstMetricsStore((s) => s.setLstMetrics);

	const getAndSetLstMetrics = async () => {
		await Promise.all(
			SUPERSTAKE_ALL_LST.map(async (lst) => {
				const metrics = await fetchLstMetrics(lst.spotMarket);
				setLstMetrics(lst.spotMarket.marketIndex, metrics as LstMetrics);
			})
		);
	};

	useInterval(() => {
		getAndSetLstMetrics();
	}, pollingRateMs);

	useEffect(() => {
		getAndSetLstMetrics();
	}, []);
};

export default useSyncLstMetricsStore;
